import { render, staticRenderFns } from "./ZboxClosureDetailDialog.vue?vue&type=template&id=6c7d7879&scoped=true&"
import script from "./ZboxClosureDetailDialog.vue?vue&type=script&lang=js&"
export * from "./ZboxClosureDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./ZboxClosureDetailDialog.vue?vue&type=style&index=0&id=6c7d7879&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7d7879",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VDialog,VDivider,VIcon,VList,VRow,VTextField,VToolbar,VToolbarTitle})
